// import APIs
import { ROSTER_COST_CENTER_DUTIES } from 'RestAPIs/endpoints';

// import external libraries
import axios from 'axios';

export interface CostCenterDutyHourType {
  id: number;
  code: string;
  description: string;
  colorCode: string;
  flags: string[];
}

export interface CostCenterDutyPeriod {
  dutyPeriodId: number;
  dutyHourType: CostCenterDutyHourType;
  startTime: string;
  endTime: string;
  overlapFlag: number;
}

export interface CostCenterDuty {
  id: number;
  displayDutyCode: string;
  dutyCode: string;
  organizationalUnitId: number;
  periods: CostCenterDutyPeriod[];
  startTime: string;
  endTime: string;
  hoursForCalculation: number;
  preferred: boolean;
  organisationColorCode: string;
}

export interface GetCostCenterDutiesParams {
  startDate: string;
  endDate: string;
  costCenters?: number;
  onlyPreferred?: boolean;
}

export const getCostCenterDuties = (params: GetCostCenterDutiesParams) => {
  return axios.get<CostCenterDuty[]>(ROSTER_COST_CENTER_DUTIES, { params });
};
